import Http from "../util/Http";

class ProductApi {
    static async getMembershipOfWriteProduct() {
        const res = await Http.get("/product/membership/write");
        return res || [];
    }

    static async getMembershipOfReadProduct() {
        const res = await Http.get("/product/membership/read");
        return res || [];
    }
}

export default ProductApi;
